import React from "react";
import "./Portfolio.css";
import "animate.css/animate.min.css";
import { AnimationOnScroll } from "react-animation-on-scroll";
function Portfolio({ darkMode }) {
  return (
    <section id="portfolio" className="portfolio">
      <h5>
        <AnimationOnScroll
          animateOnce="true"
          animateIn="animate__fadeInLeftBig"
        >
          My Recent Project
        </AnimationOnScroll>
      </h5>
      <h2>
        <AnimationOnScroll
          animateOnce="true"
          animateIn="animate__fadeInRightBig"
        >
          Portfolio
        </AnimationOnScroll>
      </h2>
      <div
        className={
          darkMode
            ? "container portfolio__content"
            : "container portfolio__content light"
        }
      >
        <AnimationOnScroll
          animateOnce="true"
          animateIn="animate__fadeInLeftBig"
        >
          <div className="card transition">
            <h2 className="transition">Ecommerce Website</h2>
            <p>
              Develop with laravel vue full stack.It takes about 3+ months for
              us to be completed. I develop this project together with my friend{" "}
              <br />
              <a
                href="https://waiphy0aung.github.io/"
                target="__blank"
                className="partner_link"
              >
                Wai Phyo Aung.
              </a>
            </p>
            <div className="card-cta-container transition">
              <a
                href="https://github.com/"
                className="card-cta btn "
                target="__blank"
              >
                GITHUB
              </a>
              <a
                href="https://laravelvue-ecommerce.herokuapp.com"
                target="__blank"
                className="card-cta btn-primary btn"
              >
                DEMO
              </a>
            </div>
            <div className="card_circle_1 card_circle transition"></div>
          </div>
        </AnimationOnScroll>

        <AnimationOnScroll
          animateIn="animate__shakeY"
          animateOut="animate__bounceOutRight"
          animateOnce="true"
        >
          <div className="card card_2 transition">
            <h2 className="transition">Socail App</h2>
            <p>
              This is Mern Stack Social Media App.Project still in development.
              I am trying to add some more awesome features and need to fix some
              layout design.
            </p>
            <div className="card-cta-container transition">
              <a
                href="https://github.com/"
                className="card-cta btn "
                target="__blank"
              >
                GITHUB
              </a>
              <a
                href="https://newsocailapp2022.herokuapp.com/"
                className="card-cta btn-primary btn"
                target="__blank"
              >
                DEMO
              </a>
            </div>
            <div className="card_circle_2 card_circle transition"></div>
          </div>
        </AnimationOnScroll>

        <AnimationOnScroll
          animateOnce="true"
          animateIn="animate__fadeInRightBig"
        >
          <div className="card transition">
            <h2 className="transition">FMG</h2>
            <p>
              Finally FMG project which is real world project that takes Longest
              time over 9+ months and still not finish yet. Company project
              developed with laravel only.
            </p>
            <div className="card-cta-container transition">
              <a
                href="https://github.com/"
                className="card-cta btn "
                target="__blank"
              >
                GITHUB
              </a>
              <a href="#" className="card-cta btn-primary btn" target="__blank">
                DEMO
              </a>
            </div>
            <div className="card_circle card_circle_3 transition"></div>
          </div>
        </AnimationOnScroll>
      </div>
    </section>
  );
}

export default Portfolio;
